import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ClassEnrolment } from 'src/app/models/class-enrolment.model';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
    selector: 'app-worker-enrolment-summary',
    templateUrl: './worker-enrolment-summary.component.html',
    styleUrls: ['./worker-enrolment-summary.component.scss'],
    standalone: false
})
export class WorkerEnrolmentSummaryComponent implements OnInit {

  @Input() enrolmentDto: ClassEnrolment;
  @Input() enrolmentRequestType: string = '';
  @Input() enrolmentRequestFor: string = '';
    isPreviewMode: boolean = true;
  constructor(
    public translateService: TranslateService, 
    public router: Router,
    public route: ActivatedRoute) 
    { }

  ngOnInit(): void {
  }


}
